import { Dialog, IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import Context from '../../provider';
import Countdown from './components/Countdown';
import React, { useContext, useEffect, useState } from 'react';
import memberApi from '../../libs/api/memberApi';

export default function LandingPopupDialog() {

  const { init, lang, imageDialog } = useContext(Context);
  const [showLandingPopup, setShowLandingPopup] = useState(false);
  const [landingPopup, setLandingPopup] = useState(null);
  const { t } = useTranslation();

  const handleClose = (_, reason) => {
    if (!landingPopup.allow_user_close && ['escapeKeyDown', 'backdropClick'].includes(reason)) return;
    setShowLandingPopup(false);
  };

  const handleClick = () => {
    if (landingPopup?.redirect_url[lang])
      window.open(landingPopup.redirect_url[lang], '_blank');
  };

  const fetchData = async () => {
    try {
      const landingPopup = await memberApi.getLandingPopup();
      if (landingPopup && landingPopup?.cover_url[lang]) {
        setLandingPopup(landingPopup);
        setShowLandingPopup(true);
        if (!landingPopup?.allow_user_close) {
          setTimeout(() => {
            setShowLandingPopup(false);
          }, landingPopup?.duration * 1000);
        }
      }
    } catch (error) {}
  };

  const fetchImageData = async () => {
    try {
      const landingPopup = await memberApi.getPage({ ruri: `add-to-home-screen` });
      if (landingPopup && landingPopup.sections.length > 0 && landingPopup.sections[0].image[lang]) {
        landingPopup.cover_url = landingPopup.sections[0].image;
        landingPopup.allow_user_close = true;
        setLandingPopup(landingPopup);
        setShowLandingPopup(true);
      }
    } catch (error) {}
  };

  useEffect(() => {
    fetchData();
  }, [init]);

  useEffect(() => {
    fetchImageData();
  }, [imageDialog]);

  return (
    <Dialog
      className='landing-pop-dialog'
      open={showLandingPopup}
      onClose={handleClose}
    >
      {landingPopup?.cover_url[lang] && (
        <img className='poster'
          src={landingPopup?.cover_url[lang]}
          alt={t('home.landingPopup')}
          onClick={handleClick} />
      )}
      {landingPopup?.allow_user_close && (
        <IconButton
          className='btn-close'
          aria-label={t('action.close')}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
      )}
      {!landingPopup?.allow_user_close && (
        <Countdown className='count-down' seconds={landingPopup?.duration}/>
      )}
    </Dialog>
  );
}